import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Button,
  Box,
  Modal,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { setScreenuser } from "../redux/slices/screenusersSlice";
import { makeStyles } from "@material-ui/core";
import { toast } from "react-toastify";
import { setLocation } from "../redux/slices/locationSlice";
import { setCustomisation } from "../redux/slices/customisationSlice";
import { setMeetingSpaces } from "../redux/slices/allMeetingSpacesSlice";
import { setResolutionsList } from "../redux/slices/resolutionSlice";
import { setTruInkAllSites } from "../redux/slices/truInk";
import callPiggybackAPI from "./TruInk/Helpers/piggyback.api.helper";
import MeetingRoomTable from "./MeetingRoomTable";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/EditNote";
import Divider from "@mui/material/Divider";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  button: {
    backgroundColor: "#2771EB",
  },
  label: {
    fontWeight: "bold",
  },
  fieldContainer: {
    display: "flex",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginRight: "2%",
    marginTop: "2%",
    width: "100%",
    overflow: "hidden",
  },
  divider: {
    margin: "20px 0",
  },
}));

const EditScreenUserForm = ({
  selectedOption,
  screenUserData,
  handleClose,
  selectedItemId,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const [screenUserName, setScreenUserName] = useState("");
  const [customizationId, setCustomizationId] = useState("");
  const [screenType, setScreenType] = useState("");
  const [locationId, setLocationId] = useState("");
  const [neighboringId, setNeighboringId] = useState([]);
  const [meetingSpaceId, setMeetingSpaceId] = useState(null);
  const [open, setOpen] = useState(true);
  const meetingOptions = useSelector((state) => state.allmeetingspaces);
  const [password, setPassword] = useState();
  const locationOptions = useSelector((state) => state.location);
  const [meetingRooms, setMeetingRooms] = useState([]);
  const api = localStorage.getItem("api");
  const [orientationOptions, setOrientationOptions] = useState({});
  const [shortNavigationOptions, setShortNavigationOptions] = useState({});
  const [isNextClicked, setIsNextClicked] = useState(false);
  const [MeetingSpaceDirections, setMeetingSpaceDirections] = useState();
  const [totalMRCount, setTotalMRCount] = useState(0);
  const [neighbourOptions, setNeighbourOptions] = useState(
    locationOptions.location
  );
  const [loading, setLoading] = useState(true);
  const [screenOrientation, setScreenOrientation] = useState("");
  const [resolution, setResolution] = useState("");
  const [kioskTemplateId, setKioskTemplateId] = useState("");
  const [kioskTemplates, setKioskTemplates] = useState([]);
  const tabs = useSelector(
    (state) => state?.user?.user?.customProperties?.tabs || []
  );
  const truInkSites = useSelector((state) => state?.truInk?.allSites || []);
  const [linkTruInk, setLinkTruInk] = useState(false);
  const [truInkTagMacAddress, setTruInkTagMacAddress] = useState("");
  const [truInkSiteId, setTruInkSiteId] = useState("");
  const [truInkTags, setTruInkTags] = useState([]);
  const [truInkTagsLoading, setTruInkTagsLoading] = useState(false);

  useEffect(() => {
    if (tabs.includes("truink") && truInkSites.length === 0) {
      callPiggybackAPI("site", {}, {}, "GET").then((response) => {
        if (response) {
          dispatch(setTruInkAllSites(response));
        }
      });
    }
  }, []);

  // Tag Mac Address is a dropdown of the digital tags belonging to the
  // selected TruInk Site, so it needs that site's tags fetched first.
  useEffect(() => {
    if (!tabs.includes("truink") || !linkTruInk || !truInkSiteId) {
      setTruInkTags([]);
      return;
    }
    const site = truInkSites.find((s) => (s.id ?? s._id) === truInkSiteId);
    if (!site) return;

    setTruInkTagsLoading(true);
    callPiggybackAPI(
      "digitalTag",
      { siteId: truInkSiteId, tenantId: site.tenantId },
      {},
      "GET"
    )
      .then((response) => setTruInkTags(Array.isArray(response) ? response : []))
      .catch(() => setTruInkTags([]))
      .finally(() => setTruInkTagsLoading(false));
  }, [linkTruInk, truInkSiteId, truInkSites, tabs]);
  const [customProperties, setCustomProperties] = useState({});
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");

  // Get resolutions from Redux
  const resolutionsList = useSelector((state) => state?.resolution?.resolutions);

  const handleScreenOrientation = async (event) => {
    setScreenOrientation(event.target.value);
  };
  const handleResolution = async (event) => {
    setResolution(event.target.value);
  };

  // Add useEffect to fetch resolutions
  useEffect(() => {
    const fetchResolutions = async () => {
      const requestBody = {
        path: "resolution",
        query: {},
        emmsId: selectedOption,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.emmsheaders?.headers,
      };

      try {
        const response = await axios.post(api + `/emms/piggyback`, requestBody, headers);
        dispatch(setResolutionsList(response.data));
      } catch (error) {
        console.error("Error fetching resolutions:", error);
      }
    };

    fetchResolutions();
  }, [selectedOption, dispatch, emmsheaders, headers, api]);
  const toggleAdvanced = () => {
    setShowAdvanced((prev) => {
      const newShowAdvanced = !prev;
      if (!newShowAdvanced) {
        setEditMode(false);
      }
      return newShowAdvanced;
    });
  };

  const toggleEditMode = () => {
    setEditMode((prev) => !prev);
  };

  const handleCustomPropertyChange = (event) => {
    const { name, value } = event.target;

    setCustomProperties((prevProperties) => ({
      ...prevProperties,
      [name]: value,
    }));
  };

  const handleAddCustomProperty = () => {
    if (newKey && newValue) {
      setCustomProperties((prevProperties) => ({
        ...prevProperties,
        [newKey]: newValue,
      }));
      setNewKey("");
      setNewValue("");
    }
  };

  const customisations = useSelector((state) => state.customisations);

  const handleNext = async () => {
    setIsNextClicked(true);
    setLoading(true);
    try {
      let allLocationIds = neighboringId ? neighboringId : "";
      if (meetingSpaceId) {
        const meetingRoom = meetingOptions?.allmeetingspaces?.find(
          (room) => room.id === meetingSpaceId
        );

        if (meetingRoom) {
          if (allLocationIds.length != 0) {
            allLocationIds += `,${meetingRoom.locationId}`;
          } else {
            allLocationIds = `${meetingRoom.locationId}`;
          }
        }
      }

      if (locationId) {
        if (allLocationIds.length != 0) {
          allLocationIds += `,${locationId}`;
        } else {
          allLocationIds = `${locationId}`;
        }
      }
      const requestBody = {
        path: "meetingspace/getbylocationId",
        query: {
          locationId: allLocationIds,
        },
        emmsId: `${selectedOption}`,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.emmsheaders?.headers,
      };

      const response = await axios.post(
        api + `/emms/piggyback`,
        requestBody,
        headers
      );

      setMeetingRooms(response.data);
      setTotalMRCount(response?.data?.length);
      setLoading(false);
      const prefilledOrientationOptions = {};
      const prefilledShortNavigationOptions = {};
      response?.data?.forEach((room) => {
        const direction = MeetingSpaceDirections[room.id]?.direction;
        if (direction) {
          prefilledOrientationOptions[room.id] = direction;
        }
        const shortNavigation =
          MeetingSpaceDirections[room.id]?.shortNavigation;
        if (shortNavigation) {
          prefilledShortNavigationOptions[room.id] = shortNavigation;
        }
      });

      setOrientationOptions(prefilledOrientationOptions);

      setShortNavigationOptions(prefilledShortNavigationOptions);
    } catch (error) {
      console.error("Error fetching meeting rooms:", error);
    }
  };

  const handleOrientationChange = (roomId, orientation) => {
    setOrientationOptions((prevOptions) => ({
      ...prevOptions,
      [roomId]: orientation,
    }));
  };
  const handleShortNavigationChange = (roomId, shortNavigationValue) => {
    setShortNavigationOptions((prevOptions) => ({
      ...prevOptions,
      [roomId]: shortNavigationValue,
    }));

    setMeetingRooms((prevRooms) =>
      prevRooms.map((room) => {
        if (room.id === roomId) {
          return { ...room, shortNavigation: shortNavigationValue };
        }
        return room;
      })
    );
  };
  const prepareMeetingSpaceDirections = (
    shortNavigationOptions,
    orientationOptions
  ) => {
    const meetingSpaceDirections = {};

    meetingRooms?.forEach((room) => {
      const roomId = room.id;
      const direction = orientationOptions[roomId];
      const shortNavigation = shortNavigationOptions[roomId];
      if (direction !== undefined || shortNavigation !== undefined) {
        meetingSpaceDirections[roomId] = { direction, shortNavigation };
      }
    });

    return meetingSpaceDirections;
  };

  useEffect(() => {
    if (Array.isArray(screenUserData)) {
      const selectedScreenuser = screenUserData.find(
        (screenuser) => screenuser.id === selectedItemId
      );

      if (selectedScreenuser) {
        setScreenUserName(selectedScreenuser.screenUserName);
        setCustomizationId(selectedScreenuser.customisationId);
        setScreenType(selectedScreenuser.typeOfScreen);
        setLocationId(selectedScreenuser.locationId || "");
        setNeighboringId(selectedScreenuser.neighbourId || []);
        setMeetingSpaceId(selectedScreenuser.meetingRoomId || null);
        setResolution(selectedScreenuser.customProperties.resolution || "");
        setScreenOrientation(
          selectedScreenuser?.customProperties?.orientation || ""
        );
        setKioskTemplateId(selectedScreenuser?.customProperties?.kioskTemplateId || "");
        setPassword(selectedScreenuser.screenUserPassword || null);
        setMeetingSpaceDirections(
          selectedScreenuser?.customProperties?.MeetingSpaceDirections
        );
        const existingTagMacAddress =
          selectedScreenuser?.customProperties?.truInkAssociatedTagMacAddress ||
          "";
        const existingTruInkSiteId =
          selectedScreenuser?.customProperties?.truInkSiteId || "";
        setTruInkTagMacAddress(existingTagMacAddress);
        setTruInkSiteId(existingTruInkSiteId);
        setLinkTruInk(Boolean(existingTagMacAddress || existingTruInkSiteId));
        const {
          resolution: _resolution,
          orientation: _orientation,
          MeetingSpaceDirections: _meetingSpaceDirections,
          totalMRCount: _totalMRCount,
          ...restCustomProperties
        } = selectedScreenuser?.customProperties || {};
        setCustomProperties(restCustomProperties);
      } else {
        setLoading(false);
        setIsNextClicked(false);
        setMeetingRooms(null);
      }
      console.log(
        "properties of screenuser prefilled",
        selectedScreenuser?.customProperties
      );
    }
  }, [screenUserData, selectedItemId]);

  const handleTypeChange = (event) => {
    const selectedType = event.target.value;
    setScreenType(selectedType);
    setLocationId("");
    setNeighboringId([]);
    setMeetingSpaceId(null);
  };

  const handleLocationIdChange = (event) => {
    const locationId = event.target.value;

    const newArray = locationOptions?.location?.filter(
      (row) => row.id !== event.target.value
    );
    setNeighbourOptions(newArray);

    setLocationId(locationId);
  };

  const handleNeighboringIdChange = (event) => {
    const neighboringId = event.target.value;
    setNeighboringId(neighboringId);
  };

  const handleMeetingSpaceIdChange = (event) => {
    const meetingSpaceId = event.target.value;
    setMeetingSpaceId(meetingSpaceId);
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (screenType !== "Kiosk") return;
    const requestBody = {
      path: "kioskStudio",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };
    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((res) => setKioskTemplates(Array.isArray(res.data) ? res.data : []))
      .catch(console.error);
  }, [screenType]);

  const getData = () => {
    const requestBody1 = {
      path: "location",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    const requestBody2 = {
      path: "customisation",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    const requestBody3 = {
      path: "meetingspace",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    const request1 = axios.post(api + `/emms/piggyback`, requestBody1, headers);
    const request2 = axios.post(api + `/emms/piggyback`, requestBody2, headers);
    const request3 = axios.post(api + `/emms/piggyback`, requestBody3, headers);

    axios
      .all([request1, request2, request3])
      .then(
        axios.spread((response1, response2, response3) => {
          dispatch(setLocation(response1.data));
          dispatch(setCustomisation(response2.data));
          dispatch(setMeetingSpaces(response3.data));
        })
      )
      .catch((error) => {
        console.error(error);
      });
  };
  const handleSubmit = (event) => {
    event.preventDefault();

    const requestBody = {
      path: "screenusers",
      query: {},
      emmsId: `${selectedOption}`,
      body: {
        screenUserName: screenUserName,
        typeOfScreen: screenType,
        locationId: locationId,
        customisationId: customizationId,
        meetingRoomId: meetingSpaceId,
        neighbourId: neighboringId,
        id: selectedItemId,
        screenUserPassword: password,
      },
      requestType: "POST",
      headers: emmsheaders?.emmsheaders?.headers,
    };
    const meetingSpaceDirections = prepareMeetingSpaceDirections(
      shortNavigationOptions,
      orientationOptions
    );

    requestBody.body.customProperties = {
      ...customProperties,
      ...requestBody.body.customProperties,
      MeetingSpaceDirections: {
        ...meetingSpaceDirections,
      },
      totalMRCount,
      orientation: screenOrientation,
      resolution: resolution,
      ...(screenType === "Kiosk" && { kioskTemplateId }),
      ...(linkTruInk && {
        truInkAssociatedTagMacAddress: truInkTagMacAddress,
        truInkSiteId: truInkSiteId,
      }),
    };

    requestBody.body = Object.fromEntries(
      Object.entries(requestBody.body).filter(([key, value]) => value !== null)
    );

    const api = localStorage.getItem("api");

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        const editedScreenUser = response.data[0];

        const index = screenUserData.findIndex(
          (user) => user.id === editedScreenUser.id
        );

        if (index !== -1) {
          const updatedScreenUserData = [...screenUserData];
          updatedScreenUserData[index] = editedScreenUser;
          dispatch(setScreenuser(updatedScreenUserData));
        } else {
          const updatedScreenUserData = [...screenUserData, editedScreenUser];
          dispatch(setScreenuser(updatedScreenUserData));
        }

        toast.success("Updated successfully", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        handleClose();
        setOrientationOptions({});
        setShortNavigationOptions({});
        setIsNextClicked(false);
        setOrientationOptions({});
        setShortNavigationOptions({});
        setShowAdvanced(false);
        setEditMode(false);
      })
      .catch((error) => {
        toast.error("Couldn't be updated", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        setIsNextClicked(false);
        setOrientationOptions({});
        setShortNavigationOptions({});
      });
  };

  const handleModalClose = () => {
    setOpen(false);
    handleClose();
    setIsNextClicked(false);
    setOrientationOptions({});
    setShortNavigationOptions({});
    setShowAdvanced(false);
    setEditMode(false);
  };
  const handleBack = () => {
    setIsNextClicked(false);
  };
  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "120px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };

  return (
    <div>
      <Modal open={open} onClose={handleModalClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            borderRadius: "10px",
            paddingTop: 1,
            paddingBottom: 4,
            paddingLeft: 4,
            paddingRight: 4,
            width:{xs:"95%",md:"unset"},
            maxWidth: {xs:"400px",md:"unset"},
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <form onSubmit={handleSubmit}>
            <h4>Edit Screen User: {screenUserName}</h4>

             {!isNextClicked && showAdvanced && (
                <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10%" }}>
                  <Button
                    style={{ textTransform: "none" ,marginRight: "10px" }}
                    variant="outlined"
                    color="primary"
                    onClick={toggleAdvanced}
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                  <Button
                    style={{ textTransform: "none" }}
                    variant="contained"
                    color="primary"
                    onClick={toggleEditMode}
                    endIcon={!editMode ? <EditIcon /> : null}
                  >
                    {editMode ? "Save Changes" : "Edit JSON"}
                  </Button>
                </div>
              )}

            {!isNextClicked && !showAdvanced && (
              <div className={classes.firstModalContent}>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Name:", true)}
                  <TextField
                    required
                    label="Name"
                    size="small"
                    value={screenUserName}
                    onChange={(e) => setScreenUserName(e.target.value)}
                    variant="outlined"
                    disabled
                    margin="normal"
                  />
                </div>

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Customisation:", true)}
                  <FormControl
                    style={{ width: "28.5ch", height: "5ch" }}
                    variant="outlined"
                    size="small"
                    margin="normal"
                  >
                    <InputLabel required>Customization ID</InputLabel>
                    <Select
                      value={customizationId}
                      onChange={(e) => setCustomizationId(e.target.value)}
                      label="Customization ID"
                    >
                      <MenuItem value="">
                        <em>-- Select --</em>
                      </MenuItem>
                      {customisations?.customisations?.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Type of Screen:", true)}
                  <FormControl
                    style={{ width: "28.5ch", height: "5ch" }}
                    variant="outlined"
                    size="small"
                    margin="normal"
                  >
                    <InputLabel required>Type of Screen</InputLabel>
                    <Select
                      value={screenType}
                      disabled
                      onChange={handleTypeChange}
                      label="Type of Screen"
                    >
                      <MenuItem value="">
                        <em>-- Select --</em>
                      </MenuItem>
                      <MenuItem value="Manager">Manager</MenuItem>
                      <MenuItem value="Navigator">Navigator</MenuItem>
                      <MenuItem value="Navigator Signage">
                        Navigator Signage
                      </MenuItem>
                      <MenuItem value="Manager Signage">
                        Manager Signage
                      </MenuItem>
                      <MenuItem value="Kiosk">Kiosk</MenuItem>
                    </Select>
                  </FormControl>
                </div>

                {screenType === "Manager" && (
                  <div className={classes.test}>
                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Meeting Space ID:", true)}
                      <FormControl
                        style={{ width: "28.5ch", height: "5ch" }}
                        variant="outlined"
                        margin="normal"
                        size="small"
                      >
                        <InputLabel required>Meeting Space ID</InputLabel>
                        <Select
                          value={meetingSpaceId}
                          onChange={handleMeetingSpaceIdChange}
                          label="Meeting Space ID"
                        >
                          <MenuItem value="">
                            <em>-- Select --</em>
                          </MenuItem>

                          {meetingOptions?.allmeetingspaces?.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Neighbouring IDs:", false)}
                      <FormControl
                        style={{ width: "28.5ch", height: "5ch" }}
                        variant="outlined"
                        margin="normal"
                        size="small"
                      >
                        <InputLabel required>Neighboring ID</InputLabel>
                        <Select
                          multiple
                          value={neighboringId}
                          onChange={handleNeighboringIdChange}
                          label="Neighboring ID"
                        >
                          <MenuItem value="">
                            <em>-- Select --</em>
                          </MenuItem>
                          {locationOptions?.location?.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.floor} {option.city} {option.building}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                )}

                {screenType === "Navigator" && (
                  <div className={classes.test}>
                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Location  ID:", true)}
                      <FormControl
                        style={{ width: "28.5ch", height: "5ch" }}
                        variant="outlined"
                        margin="normal"
                        size="small"
                      >
                        <InputLabel required>Location ID</InputLabel>
                        <Select
                          value={locationId}
                          onChange={handleLocationIdChange}
                          label="Location ID"
                        >
                          <MenuItem value="">
                            <em>-- Select --</em>
                          </MenuItem>
                          {locationOptions?.location?.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.floor} {option.city} {option.building}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Neighbouring IDs:", false)}
                      <FormControl
                        style={{ width: "28.5ch", height: "5ch" }}
                        variant="outlined"
                        margin="normal"
                        size="small"
                      >
                        <InputLabel required>Neighboring ID</InputLabel>
                        <Select
                          multiple
                          value={neighboringId}
                          onChange={handleNeighboringIdChange}
                          label="Neighboring ID"
                        >
                          <MenuItem value="">
                            <em>-- Select --</em>
                          </MenuItem>
                          {neighbourOptions?.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.floor} {option.city} {option.building}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                )}

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Orientation:", true)}
                  <TextField
                    style={{
                      width: "28.5ch",
                      height: "5ch",
                      marginTop: ".75rem",
                    }}
                    required
                    id="orientation"
                    name="orientation"
                    size="small"
                    label="Landscape or Portrait"
                    variant="outlined"
                    value={screenOrientation}
                    onChange={handleScreenOrientation}
                    select
                  >
                    <MenuItem value="landscape">Landscape</MenuItem>
                    <MenuItem value="portrait">Portrait</MenuItem>
                  </TextField>
                </div>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Resolution:", true)}
                  <FormControl
                    style={{
                      width: "28.5ch",
                      height: "5ch",
                      marginTop: ".75rem",
                    }}
                    required
                    size="small"
                    variant="outlined"
                  >
                    <InputLabel>Select Resolution</InputLabel>
                    <Select
                      id="resolution"
                      name="resolution"
                      value={resolution}
                      onChange={handleResolution}
                      label="Select Resolution"
                    >
                      <MenuItem value="" disabled>
                        Select Resolution
                      </MenuItem>
                      {resolutionsList?.map((res) => (
                        <MenuItem key={res.id} value={res.value}>
                          {res.name} ({res.value})
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                {screenType === "Kiosk" && (
                  <div className={classes.fieldContainer}>
                    {getLabelWithAsterisk("Kiosk Template:", false)}
                    <FormControl
                      style={{ width: "28.5ch", height: "5ch" }}
                      variant="outlined"
                      size="small"
                      margin="normal"
                    >
                      <InputLabel>Kiosk Template</InputLabel>
                      <Select
                        value={kioskTemplateId}
                        onChange={(e) => setKioskTemplateId(e.target.value)}
                        label="Kiosk Template"
                      >
                        <MenuItem value="">
                          <em>-- Select --</em>
                        </MenuItem>
                        {kioskTemplates.map((t) => (
                          <MenuItem key={t.id} value={t.templateId}>
                            {t.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                )}

                {tabs.includes("truink") && (
                  <div className={classes.fieldContainer}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={linkTruInk}
                          onChange={(e) => setLinkTruInk(e.target.checked)}
                        />
                      }
                      label="Link TruInk"
                    />
                  </div>
                )}

                {tabs.includes("truink") && linkTruInk && (
                  <>
                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("TruInk Site:", true)}
                      <FormControl
                        style={{ width: "28.5ch", height: "5ch" }}
                        variant="outlined"
                        size="small"
                        margin="normal"
                      >
                        <InputLabel required>TruInk Site</InputLabel>
                        <Select
                          value={truInkSiteId}
                          onChange={(e) => {
                            setTruInkSiteId(e.target.value);
                            setTruInkTagMacAddress("");
                          }}
                          label="TruInk Site"
                        >
                          <MenuItem value="">
                            <em>-- Select --</em>
                          </MenuItem>
                          {truInkSites?.map((site) => (
                            <MenuItem key={site.id} value={site.id}>
                              {site.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Tag Mac Address:", true)}
                      <FormControl
                        style={{ width: "28.5ch", height: "5ch" }}
                        variant="outlined"
                        size="small"
                        margin="normal"
                        disabled={!truInkSiteId || truInkTagsLoading}
                      >
                        <InputLabel required>Tag Mac Address</InputLabel>
                        <Select
                          value={truInkTagMacAddress}
                          onChange={(e) => setTruInkTagMacAddress(e.target.value)}
                          label="Tag Mac Address"
                        >
                          <MenuItem value="">
                            <em>
                              {!truInkSiteId
                                ? "-- Select a site first --"
                                : truInkTagsLoading
                                ? "Loading tags…"
                                : "-- Select --"}
                            </em>
                          </MenuItem>
                          {truInkTags?.map((tag) => (
                            <MenuItem key={tag.id} value={tag.macAddress}>
                              {tag.name ? `${tag.name} (${tag.macAddress})` : tag.macAddress}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </>
                )}
              </div>
            )}

            {!isNextClicked && showAdvanced && editMode && (
              <div
                style={{
                  maxWidth: "500px",
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <h6>Edit Custom Properties</h6>
                <div style={{ marginBottom: "10px" }}>
                  {Object.keys(customProperties).map((key) => (
                    <div key={key} style={{ margin: "15px 0" }}>
                      <TextField
                        id={key}
                        name={key}
                        label={key}
                        variant="outlined"
                        size="small"
                        value={
                          typeof customProperties[key] === "object"
                            ? JSON.stringify(customProperties[key])
                            : customProperties[key]
                        }
                        onChange={handleCustomPropertyChange}
                      />
                    </div>
                  ))}
                </div>
                {Object.keys(customProperties).length > 0 && (
                  <div className={classes.divider}>
                    <Divider />
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <TextField
                    id="newKey"
                    name="newKey"
                    label="New Key"
                    variant="outlined"
                    size="small"
                    value={newKey}
                    onChange={(e) => setNewKey(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <TextField
                    id="newValue"
                    name="newValue"
                    label="New Value"
                    variant="outlined"
                    size="small"
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <Button
                    style={{ textTransform: "none" }}
                    variant="contained"
                    color="primary"
                    onClick={handleAddCustomProperty}
                  >
                    Add
                  </Button>
                </div>
              </div>
            )}

             

            {!isNextClicked && showAdvanced && (
              <div
                style={{
                  maxWidth: "500px",
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <h6>Custom Properties</h6>
                <pre
                  style={{
                    whiteSpace: "pre-wrap",
                    wordWrap: "break-word",
                  }}
                >
                  {JSON.stringify(customProperties, null, 2)}
                </pre>
              </div>
            )}

            {isNextClicked && (
              <div className={classes.secondModalContent}>
                <h3>Meeting Rooms</h3>
                {loading ? (
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={open}
                    onClick={handleClose}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
                ) : (
                  <MeetingRoomTable
                    meetingRooms={meetingRooms}
                    orientationOptions={orientationOptions}
                    shortNavigationOptions={shortNavigationOptions}
                    handleOrientationChange={handleOrientationChange}
                    handleShortNavigationChange={handleShortNavigationChange}
                  />
                )}
              </div>
            )}

            <div className={classes.buttonContainer}>
              {isNextClicked && (
                <Button
                  style={{
                    marginTop: "10%",
                    textTransform: "none",
                    marginRight: "50%",
                  }}
                  onClick={handleBack}
                  variant="outlined"
                  color="primary"
                >
                  Back
                </Button>
              )}
              {isNextClicked && (
                <Button
                  style={{ marginTop: "10%", textTransform: "none" }}
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  Update
                </Button>
              )}
              {isNextClicked && (
                <Button
                  style={{ marginTop: "10%", textTransform: "none" }}
                  variant="outlined"
                  color="primary"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
              )}

              {!isNextClicked && !showAdvanced && (
                <>
                  <Button
                    style={{ marginTop: "10%", textTransform: "none" }}
                    variant="outlined"
                    color="primary"
                    onClick={handleClose}
                  >
                    Back
                  </Button>
                  <Button
                    style={{ marginTop: "10%", textTransform: "none" }}
                    variant="outlined"
                    color="primary"
                    onClick={toggleAdvanced}
                  >
                    Advanced
                  </Button>
                  {screenType === "Kiosk" ? (
                    <Button
                      style={{
                        marginTop: "10%",
                        textTransform: "none",
                      }}
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      Update
                    </Button>
                  ) : (
                    <Button
                      style={{
                        marginTop: "10%",
                        textTransform: "none",
                      }}
                      onClick={handleNext}
                      variant="contained"
                      color="primary"
                    >
                      Next
                    </Button>
                  )}
                </>
              )}
            </div>
          </form>
        </Box>
      </Modal>
    </div>
  );
};

export default EditScreenUserForm;
